import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDVIIYKYtxnHBAGZwfaJAJk4B4gSMFbpIU',
  authDomain: 'currentcare-8896f.firebaseapp.com',
  projectId: 'currentcare-8896f',
  storageBucket: 'currentcare-8896f.firebasestorage.app',
  messagingSenderId: '662453296459',
  appId: '1:662453296459:web:cf290c762f94f7f29f5cce',
  measurementId: 'G-ZT07EQJZ53',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
